import * as API from '../api'
export const FETCH_SEVERITY = 'FETCH_SEVERITY'
export const FETCHING_SEVERITY = 'FETCHING_SEVERITY'
export const FETCH_SEVERITY_ERROR = 'FETCH_SEVERITY_ERROR'
export const FETCH_SEVERITIES = 'FETCH_SEVERITIES'
export const FETCH_SEVERITIESALL = 'FETCH_SEVERITIESALL'
export const FETCHING_SEVERITIES = 'FETCHING_SEVERITIES'
export const FETCH_SEVERITIES_ERROR = 'FETCH_SEVERITIES_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_SEVERITY = 'CHANGE_SEVERITY'
export const DELETE_SEVERITY = 'DELETE_SEVERITY'
export const ADD_SEVERITY = 'ADD_SEVERITY'
export const EDIT_SEVERITY = 'EDIT_SEVERITY'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_SEVERITY = 'NEW_FORM_SEVERITY'
export const SEVERITY_FORM_ERROR = 'SEVERITY_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeSeverity = severity => {
  return dispatch => {
    dispatch({ type: CHANGE_SEVERITY, severity })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const handleSeverityError = (res, dispatch) => {
  const { data: errorMessage = '' } = res

  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: SEVERITY_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newFormSeverity = severity => {
  return dispatch => {
    dispatch({ type: NEW_FORM_SEVERITY })
  }
}

export const setSeverityFormTouched = severity => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreSeverity = id => {
  return dispatch => {
    dispatch({ type: FETCHING_SEVERITIES })
    return API.severities
      .restoreSeverity(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_SEVERITY, severity: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_SEVERITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleSeverityError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchSeveritiesAll = () => {
  return dispatch => {
    API.severities.getSeveritiesAll().then((res = {}) => {
      const { data } = res
      dispatch({ type: FETCH_SEVERITIESALL, severities: data })
    })
  }
}

export const fetchSeverities = options => {
  return dispatch => {
    dispatch({ type: FETCHING_SEVERITIES })
    return API.severities
      .getSeverities(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_SEVERITIES,
          severities: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_SEVERITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const deleteSeverity = id => {
  return dispatch => {
    dispatch({ type: FETCHING_SEVERITIES })
    return API.severities
      .deleteSeverity(id)
      .then(({ data: severity }) => {
        dispatch({ type: DELETE_SEVERITY, severity })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_SEVERITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addSeverity = severity => {
  return dispatch => {
    dispatch({ type: FETCHING_SEVERITIES })
    dispatch({ type: FETCHING_SEVERITY })
    return API.severities
      .addSeverity(severity)
      .then(({ data }) => {
        dispatch({ type: ADD_SEVERITY, severity: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleSeverityError(response, dispatch)
        dispatch({
          type: FETCH_SEVERITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editSeverity = severity => {
  return dispatch => {
    dispatch({ type: FETCHING_SEVERITIES })
    dispatch({ type: FETCHING_SEVERITY })
    return API.severities
      .editSeverity(severity)
      .then(({ data }) => {
        dispatch({ type: EDIT_SEVERITY, severity: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_SEVERITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleSeverityError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchSeverity = id => {
  return dispatch => {
    dispatch({ type: FETCHING_SEVERITY, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.severities
      .getSeverity(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_SEVERITY, severity: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_SEVERITY_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/severities.js